import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import {
  CLIENT_VIEWS,
  InlineEdit,
  InlineEditTableWrapper,
  TEXT_LENGTH
} from '@nile/components';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

import InlineSelect from '@nile/components/src/Components/InlineEdit/Components/InlineSelect';
import InlineText from '@nile/components/src/Components/InlineEdit/Components/InlineText';
import { isEmpty } from 'lodash';
import Tippy from '@tippyjs/react';
import { DisplayText } from '@superops/ui-design-system';

const Wrapper = styled.div`
  .subject-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: auto;
    overflow: hidden;
  }

  .inline-edit--readview:hover {
    ${(props) => props.editable && `background: #ffffff !important;`}
  }
`;

function InvoiceAuditNotesCell(props) {
  const { cell, intl, data } = props;
  const meta = cell?.row?.original;
  const { actions, field, view } = cell.column;
  const value = meta[field.name];
  const [edit, setEdit] = useState(false);
  const isEditable = cell?.column?.isEditable;

  return (
    <Tippy
      content={
        <div className="p12 scroll wm-600 mh-400  border-radius-inherit line-break-anywhere">
          <DisplayText element="p" size="medium" weight="Regular">
            {value}
          </DisplayText>
        </div>
      }
      duration={250}
      delay={500}
      interactive
      placement="bottom-start"
      arrow={false}
      allowHTML
      theme="light"
      appendTo={document.body}
      disabled={isEmpty(value)}
    >
      <Wrapper editable={isEditable} className="fx actr no-scroll">
        <InlineText
          editMode={edit}
          setEditState={setEdit}
          multiline
          variant={`subdued ${isEmpty(value) ? 'opacity5' : ''}`}
          actionClass="action-button"
          wrapperClassname={`${isEditable ? 'editable-cell ' : ''}${
            edit ? 'fw' : ''
          }`}
          defaultValue={value}
          saveValue={(val, cb) => {
            if (val !== value) {
              actions.updateAudit(meta, 'notes', val, cb);
            } else {
              if (cb) cb('');
              setEdit(false);
            }
          }}
          editable={isEditable}
          maxLength={3000}
        />
      </Wrapper>
    </Tippy>
  );
}

export default injectIntl(InvoiceAuditNotesCell);
